import { z } from "zod";

export function createAppointmentFormSchema(customFieldsData: Array<{
  key: string;
  title: string;
  required: boolean;
}>) {
  // checking if the custom fields are required in the api and based on
  // that we are creating the schema for the custom fields
  const customFieldsSchema = z.array(z.string()).superRefine((data, ctx) => {
    data.forEach((value, index) => {
      const field = customFieldsData[index];
      if (field?.required && value.trim() === "") {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "field-required",
          path: [index],
        });
      }
    });
  });

  return z.object({
    firstName: z.string().min(1, "first-name-required"),
    lastName: z.string().min(1, "last-name-required"),
    email: z.string().email("invalid-email"),
    phone: z.string().min(4, "phone-required"),
    gender: z
      .object({
        label: z.string(),
        value: z.string(),
      })
      .refine(
        (data) => {
          if (data.value === "") {
            return false;
          }
          return true;
        },
        {
          message: "select-gender",
        },
      ),
    customFields: customFieldsSchema,
    message: z.string(),
  });
}
